import _typeof from "@babel/runtime/helpers/typeof";

/* eslint-disable @typescript-eslint/no-explicit-any */
var isPlainObject = function isPlainObject(item) {
  return _typeof(item) === 'object' && item !== null && item.constructor === Object;
};

export default isPlainObject;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/utils/dist/esm/isPlainObject/index.js
// module id = 1040
// module chunks = 12